export function openWhatsAppSupport() {
  return window.open(
    'https://api.whatsapp.com/send?phone=551130049680&text=Oi,%20voc%C3%AA%20poderia%20me%20ajudar?%20',
    '_blank'
  )
}
